import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { IndependentIraUser } from 'services/requests';
import { ApiError } from 'services/api.errors';
import { MutationKeys } from 'constants/mutationKeys';

export const useCheckIndependentIraEmail = () => {
  const mutate = async (email: string) => {
    const { data } = await api.checkIndependentIraEmail(email);
    return data;
  };

  const mutationKey = MutationKeys.checkIndependentIraEmail;

  return useMutation<IndependentIraUser, AxiosError<ApiError>, string>(
    mutationKey,
    mutate,
  );
};
